export interface UgcExperienceOption {
  value: string;
  fr: string;
  en: string;
}

export const UGC_EXPERIENCE_OPTIONS: UgcExperienceOption[] = [
  { value: '< 1 an', fr: "Moins d'1 an", en: 'Less than 1 year' },
  { value: '1-3 ans', fr: '1 à 3 ans', en: '1 to 3 years' },
  { value: '3-5 ans', fr: '3 à 5 ans', en: '3 to 5 years' },
  { value: '> 5 ans', fr: 'Plus de 5 ans', en: 'More than 5 years' },
];

export function getUgcExperienceLabel(value: string, lang: 'fr' | 'en' = 'fr'): string {
  const opt = UGC_EXPERIENCE_OPTIONS.find((o) => o.value === value);
  return opt ? opt[lang] : value;
}
